import css from 'styled-jsx/css';

const styles = css.global`#meu-financiamento-antecipar {
    background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
    padding: 48px 0 129px;
    position: relative;
}

#meu-financiamento-antecipar .antecipar-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}


#meu-financiamento-antecipar .antecipar-titulo {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 56px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
    margin-bottom: 24px;
    margin-top: 0;
}

#meu-financiamento-antecipar .antecipar-paragrafo {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    margin-bottom: 40px;
    z-index: 9;
    position: relative;
}

#meu-financiamento-antecipar .item .antecipar-paragrafo {
    /* max-width: 273px; */
    margin-top: 16px;
}

#meu-financiamento-antecipar .btn-antecipar {
    width: 100%;
    height: 48px;
    max-width: 272px;
    margin: auto;
}

#meu-financiamento-antecipar .antecipar-calendar {
    mix-blend-mode: multiply;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    opacity: .65;
}

#meu-financiamento-antecipar .is-desk {
    display: none;
}

.antecipar-wpp {
    display: block;
    background: #DEEDF2;
    padding: 48px 0px;
    display: flex;
    align-items: center;
}

.antecipar-wpp-content {
    display: flex;
    justify-content: space-between;
}

.antecipar-wpp-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    margin-bottom: 16px;
    margin-top: 0;
}

.antecipar-wpp-titulo b {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 36px;
}

.antecipar-wpp-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.antecipar-wpp-paragrafo a {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
}
.antecipar-wpp img {
    display: none;
}

@media(min-width: 992px) {
    #meu-financiamento-antecipar .antecipar-content {
        max-width: 900px;
        flex-direction: row;
        justify-content: space-between;
        z-index: 9;
        position: relative;
    }

    #meu-financiamento-antecipar .is-mob {
        display: none;
    }

    #meu-financiamento-antecipar .is-desk {
        display: block;
    }

    #meu-financiamento-antecipar .antecipar-calendar {
        transform: translate(0, 0);
        left: auto;
    }

    #meu-financiamento-antecipar .btn-antecipar.is-desk {
        display: flex;
        margin-top: 8px;
        margin-left: 0;
    }

    .antecipar-calendar.is-desk {
        right: 0;
        bottom: 0;
    }

    #meu-financiamento-antecipar {
        padding: 72px 0;
    }

    #meu-financiamento-antecipar .item {
        width: 100%;
    }

    #meu-financiamento-antecipar .antecipar-titulo {
        margin-top: 0;
        z-index: 9;
        position: relative;
        margin-bottom: 16px;
    }

    #meu-financiamento-antecipar .antecipar-paragrafo {
        margin-bottom: 58px;
    }

    #meu-financiamento-antecipar .antecipar-paragrafo.p1 {
        max-width: 200px;
    }

    .antecipar-wpp.is-desk {
        display: block;
        background: #DEEDF2;
        height: 364px;
        padding: 48px 0px;
        display: flex;
        align-items: center;
    }

    .antecipar-wpp-content {
        padding: 0 90px;
        display: flex;
        justify-content: space-between;
    }

    .antecipar-wpp-titulo {
        color: #444;
        font-family: "SantanderHeadline";
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
        margin-bottom: 16px;
        margin-top: 0;
    }

    .antecipar-wpp-titulo b {
        color: #444;
        font-family: "SantanderHeadline";
        font-size: 32px;
        font-style: normal;
        font-weight: 800;
        line-height: 120%;
    }

    .antecipar-wpp-paragrafo {
        color: #444;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
    }

    .antecipar-wpp-paragrafo .is-desk {
        display: inline;
    }

    .antecipar-wpp-paragrafo a {
        color: #444;
        font-family: "SantanderText";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
    }
    .antecipar-wpp img {
        display: block;
        width: 201px;
        border-radius: 4px;
    }
}`;

export default styles;